/** Shared Overview money-card aggregation (#1061). */
import { BUILT_IN_EXPENSE_CATEGORIES } from '../expenses/expenses';
import { computeOverviewVehicleProfit, daysToSellForVehicle, emptyOverviewMonthRollup, monthBoundsMs, overviewMonthPeriodKey, } from './overviewRollup';
const isSoldStatus = (status) => {
    const normalized = (status || '').toLowerCase().trim();
    return normalized === 'sold' || normalized === 'sold elsewhere';
};
const isReviewedExpense = (expense) => !expense.reviewStatus || expense.reviewStatus === 'reviewed';
export const computeOverviewRangeMetrics = (startMs, endMs, vehicles, expenses) => {
    const expensesByCategory = {};
    const expenseLinkedVehicleCounts = {};
    for (const category of BUILT_IN_EXPENSE_CATEGORIES) {
        expensesByCategory[category] = 0;
        expenseLinkedVehicleCounts[category] = 0;
    }
    let soldCount = 0;
    let totalRevenue = 0;
    let totalProfit = 0;
    let daysToSellSum = 0;
    let expenseTotal = 0;
    for (const vehicle of vehicles) {
        if (!isSoldStatus(vehicle.status) || !vehicle.sold_date)
            continue;
        const soldMs = new Date(vehicle.sold_date).getTime();
        if (!Number.isFinite(soldMs) || soldMs < startMs || soldMs > endMs)
            continue;
        soldCount += 1;
        totalRevenue += vehicle.optic_list_price || 0;
        totalProfit += computeOverviewVehicleProfit(vehicle);
        daysToSellSum += daysToSellForVehicle(vehicle);
    }
    for (const expense of expenses) {
        if (!isReviewedExpense(expense) || !expense.date)
            continue;
        const expenseMs = new Date(expense.date).getTime();
        if (!Number.isFinite(expenseMs) || expenseMs < startMs || expenseMs > endMs)
            continue;
        const category = expense.category || 'Other';
        const amount = expense.amount || 0;
        expensesByCategory[category] = (expensesByCategory[category] ?? 0) + amount;
        expenseTotal += amount;
        if (expense.vehicleId) {
            expenseLinkedVehicleCounts[category] = (expenseLinkedVehicleCounts[category] ?? 0) + 1;
        }
    }
    return {
        soldCount,
        totalRevenue,
        totalProfit,
        daysToSellSum,
        expenseTotal,
        expensesByCategory,
        expenseLinkedVehicleCounts,
        avgDaysToSell: soldCount > 0 ? daysToSellSum / soldCount : 0,
        roi: totalRevenue > 0 ? (totalProfit / totalRevenue) * 100 : 0,
    };
};
export const computeOverviewMonthRollup = (year, monthIndex0, vehicles, expenses) => {
    const periodKey = overviewMonthPeriodKey(year, monthIndex0);
    const { startMs, endMs } = monthBoundsMs(year, monthIndex0);
    const metrics = computeOverviewRangeMetrics(startMs, endMs, vehicles, expenses);
    return {
        ...emptyOverviewMonthRollup(periodKey, startMs, endMs),
        soldCount: metrics.soldCount,
        totalRevenue: metrics.totalRevenue,
        totalProfit: metrics.totalProfit,
        daysToSellSum: metrics.daysToSellSum,
        expenseTotal: metrics.expenseTotal,
        expensesByCategory: metrics.expensesByCategory,
        expenseLinkedVehicleCounts: metrics.expenseLinkedVehicleCounts,
        updatedAt: new Date().toISOString(),
    };
};
